// @flow
import { SubmissionError } from 'redux-form';

export function assignBankAccountToProperty(
  accountName: string,
  account: string,
  accounts: Array<{ label: string }>
): boolean {
  const accountArray = accounts.map(obj => {
    return obj.label.toLowerCase();
  });
  if (account === 'Create New Bank Account') {
    if (accountName !== null && accountName !== undefined) {
      if (accountArray.includes(accountName.toLowerCase())) {
        throw new SubmissionError({
          _error: 'This account already exists.',
        });
      }

      if (accountName === '') {
        throw new SubmissionError({
          _error: 'Bank Account name cannot be blank.',
        });
      }
    } else {
      throw new SubmissionError({
        _error: 'Bank Account name cannot be blank.',
      });
    }
  }

  return true;
}
